// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"67e9a8f4","178":"20d36bff","359":"80bc06dc","720":"c6528246","808":"53a09918"}[chunkId] + ".css";
};